import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScreenshotService {

  /**
   * Enable screenshot mode for full-page capture
   * This temporarily modifies the page layout to show all content
   */
  enableScreenshotMode(): void {
    document.documentElement.classList.add('screenshot-mode');
    document.body.classList.add('screenshot-mode');
    
    // Also add some inline styles for maximum compatibility
    const style = document.createElement('style');
    style.id = 'screenshot-mode-styles';
    style.textContent = `
      html.screenshot-mode,
      body.screenshot-mode {
        height: auto !important;
        overflow: visible !important;
        overflow-y: visible !important;
        max-height: none !important;
      }
      
      .screenshot-mode app-root {
        height: auto !important;
        overflow: visible !important;
        max-height: none !important;
        display: block !important;
      }
      
      .screenshot-mode .main-content,
      .screenshot-mode .profile-content {
        overflow: visible !important;
        max-height: none !important;
        height: auto !important;
      }
    `;
    document.head.appendChild(style);
    
    console.log('Screenshot mode enabled - page should now show full content');
  }

  /**
   * Disable screenshot mode and restore normal layout
   */
  disableScreenshotMode(): void {
    document.documentElement.classList.remove('screenshot-mode');
    document.body.classList.remove('screenshot-mode');
    
    const screenshotStyles = document.getElementById('screenshot-mode-styles');
    if (screenshotStyles) {
      screenshotStyles.remove();
    }
    
    console.log('Screenshot mode disabled - normal layout restored');
  }

  /**
   * Enable screenshot mode temporarily and then restore
   * @param duration Duration in milliseconds (default: 5000ms = 5 seconds)
   */
  enableScreenshotModeTemporarily(duration: number = 5000): void {
    this.enableScreenshotMode();
    
    setTimeout(() => {
      this.disableScreenshotMode();
    }, duration);
    
    console.log(`Screenshot mode enabled for ${duration}ms`);
  }

  /**
   * Prepare page for printing by enabling print-friendly styles
   */
  preparePageForPrinting(): void {
    // Add print class for additional styling if needed
    document.body.classList.add('print-mode');
    
    // Trigger browser's print dialog
    setTimeout(() => {
      window.print();
      
      // Clean up after print dialog closes
      setTimeout(() => {
        document.body.classList.remove('print-mode');
      }, 1000);
    }, 100);
  }

  /**
   * Get the full page height including scrollable content
   */
  getFullPageHeight(): number {
    return Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight
    );
  }

  /**
   * Get viewport dimensions
   */
  getViewportDimensions(): { width: number; height: number } {
    return {
      width: Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0
      ),
      height: Math.max(
        document.documentElement.clientHeight || 0,
        window.innerHeight || 0
      )
    };
  }
}